/** Explicit output profiles; never accept encoder names or command arguments from clients. */
export type NativeOutputFormat = 'mp4' | 'webm';

export function readNativeOutputFormat(value: unknown): NativeOutputFormat {
  if (value === undefined || value === 'mp4') return 'mp4';
  if (value === 'webm') return 'webm';
  throw new Error('출력 형식을 확인해 주세요.');
}

export function nativeOutputProfile(value: unknown) {
  const format = readNativeOutputFormat(value);
  return format === 'webm'
    ? {format, extension: 'webm', mimeType: 'video/webm', codec: 'vp8'} as const
    : {format, extension: 'mp4', mimeType: 'video/mp4', codec: 'h264'} as const;
}
